import template from './has-grace-period.jade';
import itemsYesNo from '../../../enums/yes-no';

export default angular
    .module('cian.addForm.hasGracePeriod', ['cian.addForm.fieldTypeSwitcher'])
    .directive('cianAfPriceAndDealTermsHasGracePeriod', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller() {
            this.items = itemsYesNo;
        },
        controllerAs: 'hasGracePeriod',
        template,
    }))
    .name;
